<form [formGroup]="formGroup" nz-form [ngClass]="{ 'packed-form': isPacked() }">
    @if (packageType() === "box") {
        <article pfArticle pfTitle="Package information">
            <div
                class="box-option-selection pf-form-group column"
                [ngClass]="{ compact: !isMobile() }">
                <pf-select
                    class="pf-full-width"
                    label="Select package type"
                    [pfDisabled]="disabled() || isPacked()"
                    [pfStyle]="inputStyle()"
                    [data]="boxOptions()"
                    [noDefaultOption]="true"
                    controlName="selectedBox"
                    (selected)="onBoxSelected($event)"></pf-select>
            </div>
        </article>
    }

    @if (hasItems) {
        <article pfArticle pfTitle="Items in this package">
            <div class="item-checklist">
                <div class="item-row header" [ngClass]="{ mobile: isMobile() }">
                    <label
                        nz-checkbox
                        [nzChecked]="allItemsChecked()"
                        [nzIndeterminate]="someItemsChecked()"
                        [nzDisabled]="disabled() || isPacked()"
                        (nzCheckedChange)="onToggleAll()">
                        <strong>Toggle All</strong>
                    </label>
                </div>
                @for (
                    row of itemRows.controls;
                    track row.controls.itemId.value;
                    let i = $index
                ) {
                    <div
                        class="item-row"
                        [formGroup]="row"
                        [ngClass]="{ mobile: isMobile() }">
                        <label
                            nz-checkbox
                            formControlName="checked"
                            [nzDisabled]="disabled() || isPacked()"
                            (nzCheckedChange)="onItemCheckedChange(i)">
                            {{ row.controls.itemDescription.value }}
                        </label>
                        @if (row.controls.checked.value) {
                            <cpw-quantity-input
                                class="item-quantity"
                                [disabled]="disabled() || isPacked()"
                                [min]="0"
                                [max]="row.controls.maxQuantity.value"
                                [control]="
                                    row.controls.quantity
                                "></cpw-quantity-input>
                        }
                    </div>
                }
            </div>
            <div
                class="package-weight pf-form-group column"
                [ngClass]="{ compact: !isMobile() }">
                <pf-input
                    #weightInput
                    class="pf-full-width"
                    inputType="number"
                    inputSuffix="lbs"
                    label="Place package on scale and enter weight"
                    [pfDisabled]="disabled() || isPacked()"
                    [pfStyle]="inputStyle()"
                    controlName="weightLbs"></pf-input>
            </div>
        </article>
    }
</form>
